import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import { changePreviewImage } from './history-slider'
import { activeUnactiveNav } from './gallery-slider'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation])

const quotesSlider = (quoteDiv) => {
    const swiper = new Swiper(quoteDiv , {
        grabCursor: true,
        centeredSlidesBounds: true,
        spaceBetween: 40,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        
        on: {
            init: function(){
                console.log(document.querySelectorAll('.ia-block-listing-quotes__item').length)
                if(document.querySelectorAll('.ia-block-listing-quotes__item').length > 1) {
                    changePreviewImage(quoteDiv, false, true)
                }
            },
            beforeTransitionStart: function(e){
                let isEnd = false
                if (e.isEnd) {
                    isEnd = true
                }

                let isBegin = false
                if (e.isBeginning) {
                    isBegin = true
                }
                if(document.querySelectorAll('.ia-block-listing-quotes__item').length > 1) {
                    changePreviewImage(quoteDiv, isEnd, isBegin)
                }
            },   
            slideChange: function(e){
                activeUnactiveNav(e, quoteDiv)
            },  
        }
    })

    quoteDiv.querySelector('.ia-custom-navigation__swiper-button-next').addEventListener('click', function(e) {
        e.preventDefault()
        swiper.slideNext()
    })
    quoteDiv.querySelector('.ia-custom-navigation__swiper-button-prev').addEventListener('click', function(e) {
        e.preventDefault()
        swiper.slidePrev()
    })


}



export {quotesSlider}